module.exports = __webpack_public_path__ + "static/media/workflow@3x.9e0c964e.png";